export default __webpack_public_path__ + "static/media/clock.49bbc5ed.svg";